/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
/**
 * Shape helper class
 **/

define([], () => {

	class ShapeUtils {
		/**
		 * Add a shape widget to the given content
		 * @param {object} content - content
		 * @param {object} options - options.shapeModel object - the model of a shape
		 * @param {object} transactionToken 
		 */
		static addShapeWidgetToContent(content, options, transactionToken) {
			const oShapeModel = options.shapeModel;
			content.setPropertyValue('value.graphic.fillColor', oShapeModel.fillColor, transactionToken);
			content.setPropertyValue('value.graphic.borderColor', oShapeModel.borderColor, transactionToken);
			content.setPropertyValue('value.graphic.content', oShapeModel.content, transactionToken);
		}
	}
	return ShapeUtils;
});
